import React, { useState, useMemo, forwardRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { ButtonBase, Checkbox } from '@material-ui/core';
import moment from 'moment';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Newbooking from '../PopWindows/Newbooking';
import { i18n } from '../../../../language';
import { bsMlookupListFunc } from '../../bsEnumeration';
import { GenderIcon } from '../../../../components';
import { classNames, conditional, initValue } from '../../../../utils';
import { EditIcon, SeeIcon } from '../../../../components/Icon';
import PageList from '../../../../components/PageList';
import { LoginPop } from '../../../../components/Login';
import StyleButton from '../../../../components/StyleButton';
import { PatientUI } from '../InternalBooking/TransferInTable/Row';
import { maskChineseName, maskEnglishName } from '../../../../utils/admissionUtil';
import { AckInfo } from '../../../Admission/components/BusStop/components';

const useStyles = makeStyles({
  root: ({ padding }) => ({
    overflow: 'auto',
    padding,
    backgroundColor: '#fff',
    flex: 1,
  }),
  padd: {
    padding: '0 !important',
  },
  tableBody: {},
  table: {
    position: 'relative',
    minWidth: '65rem',
    '& .MuiTableCell-root': {
      border: 'none',
      fontSize: '0.875rem',
      fontWeight: '500',
      lineHeight: '1.675rem',
      color: '#2e4469',
      padding: '0.813rem 1.25rem',
    },
    '& .MuiTableHead-root': {
      position: 'sticky',
      top: '0',
      left: '0',
      zIndex: '10',
      '& .MuiTableRow-root': {
        backgroundColor: '#fff',
      },
      '& .MuiTableCell-root': {
        fontWeight: 'bold',
        color: '#538fff',
        backgroundColor: '#fff',
        textTransform: 'uppercase',
      },
    },
    '& .MuiTableBody-root': {
      '& > :hover': {
        backgroundColor: '#f5faff',
      },
      '& > .MuiTableRow-root': {
        borderBottom: '1px solid #E6E8E9',
      },
      '& .MuiTableCell-root': {
        height: '3.5rem',
        fontFamily: 'NotoSans-Medium',
      },
    },
    '& .Mui-selected': {
      backgroundColor: '#defff5',
    },
    '& .MuiCheckbox-colorSecondary.Mui-checked': {
      color: '#28d2ab',
    },
  },
  status: {
    width: '0.625rem',
    height: '0.625rem',
    display: 'inline-block',
    borderRadius: '50%',
    marginRight: '0.563rem',
  },
  editBtn: {
    width: '2.25rem',
    height: '2.25rem',
    minWidth: '0',
    backgroundColor: '#4c93ff',
    borderRadius: '0.625rem',
    color: '#fff',
    '&:hover': {
      background: '#4c93ff !important',
    },
  },
  editIcon: {
    fontSize: '1rem',
    '&:hover': {
      background: '#4c93ff !important',
    },
  },
  seeIcon: {
    fontSize: '1.5rem',
    '&:hover': {
      background: '#4c93ff !important',
    },
  },
  tableHead: {
    whiteSpace: 'nowrap',
  },
  statusCell: {
    whiteSpace: 'nowrap',
  },
  patient: {
    overflowWrap: 'normal',
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'center',
  },
  remark: {
    // whiteSpace: 'break-spaces',
  },
});

export default forwardRef(function BookingTable(
  {
    className,
    allData,
    saveHandle,
    editPopChange,
    onRead,
    bsMlookupList,
    nextPageCall,
    pageSize,
    hideIndex,
    showCheckbox = false,
    onChangeCheckbox,
    seeIcon = false,
    setRefresh,
    setIsLoading,
    currentBed,
    tablePadding = false,
    ticket,
    handleAck,
    handleClosePopup,
    isHistory,
    padding = '0 1.875rem',
    remarkMinWidth = '15rem',
    checkBoxPadding = '0.813rem 0.5rem',
  },
  ref
) {
  const classes = useStyles({ padding });
  const [isShowPop, setIsShowPop] = useState(false);
  const language = useSelector((state) => state.settings.language);
  const isLogin = useSelector((state) => state.loginInfo.flag);
  const [loginPopup, setLoginPopup] = useState(false);
  const history = useHistory();

  const showPop = (index, type, eaId, transferRequestId) => {
    return () => {
      if (isLogin) {
        setEditIndex(index);
        if (type === 'EADM') {
          history.push(`/bedstatusForm/${eaId}?transferRequestId=${transferRequestId}`);
        } else {
          editPopChange?.(true);
          setIsShowPop(true);
        }
      } else {
        setLoginPopup(true);
      }
    };
  };
  const closePop = () => {
    setIsShowPop(false);
    editPopChange?.(false);
    handleClosePopup?.();
  };

  const dateTimeCtr = (targetArriveDtm) => {
    const dateTime = moment(targetArriveDtm);
    return dateTime.isValid() ? dateTime.format('YYYY-MM-DD HH:mm') : '';
  };
  const bsStatus = useMemo(() => {
    return bsMlookupListFunc.getBSBookStatusAddTranslate(bsMlookupList);
  }, [bsMlookupList, language]);
  const bsMlookupListStatus = useMemo(() => {
    let addStatus = [
      { lookUpName: 'Pending Adm.', lookUpValue: 'O' },
      { lookUpName: i18n.t('BEDSTATUS_COMPLETED_SINCE_24HOURS_AGO'), lookUpValue: 'C' },
      { lookUpName: i18n.t('BEDSTATUS_DELETED'), lookUpValue: 'D' },
    ];
    return addStatus;
  }, [bsMlookupList]);
  const statusCtr = (status) => {
    const styles = {
      O: { background: '#5cd9f4' },
      C: { background: '#28D2AB' },
      D: { background: '#C7C7C7' },
      PFYA: { background: '#ffc95c' },
      P: { background: '#ffc95c' },
      A: { background: '#5cd9f4' },
      DL: { background: '#ff655c' },
    };
    const statusEnum =
      _.find(bsStatus, (item) => {
        return item.value === status;
      })?.text ?? '';
    return (
      <>
        <span className={classes.status} style={styles[status]} />
        {statusEnum}
      </>
    );
  };

  const editCtr = (index, type, eaId, transferRequestId) => {
    return (
      <ButtonBase className={classes.editBtn} onClick={showPop(index, type, eaId, transferRequestId)}>
        {seeIcon ? <SeeIcon className={classes.seeIcon} /> : <EditIcon className={classes.editIcon} />}
      </ButtonBase>
    );
  };

  const specialty_hospital_ward_bedNoCtr = (specialty, fromHospCode, fromWardLocation, bedNo) => {
    return `${specialty ?? '-'} / ${fromHospCode ?? '-'} /${fromWardLocation ?? '-'} / ${bedNo ?? '-'}`;
  };

  const [EditIndex, setEditIndex] = useState(-1);
  // lookup回来后要重新整理rows，否则第一次进入时status可能只有颜色没有文字。
  const rows = useMemo(() => {
    return _.map(allData, (item, index) => {
      return {
        ...item,
        id: item.transferRequestId,
        eaId: item.eaId,
        status: statusCtr(item.status),
        dateTime: dateTimeCtr(item.targetArriveDtm),
        // patient: patientCtr(item.patGender, item.caseNo, item.age),
        patient: {
          caseNo: item.caseNo,
          name: isLogin ? getFullName(item.chiName, item.patName) : getMaskedName(item.chiName, item.patName),
          gender: item.patGender,
          age: item.age,
        },
        admissionType:
          item.admissionType === 'EADM'
            ? item.admissionType
            : bsMlookupListFunc.getTypeLookupName(bsMlookupList, 'bs_clinical_admission', item.admissionType) ?? '',
        edit: editCtr(index, item.admissionType, item.eaId, item.transferRequestId),
        specialty_hospital_ward_bedNoCtr: specialty_hospital_ward_bedNoCtr(
          item.eisSpecCd,
          item.fromHospCode,
          item.fromWardLocation,
          item.fromBedNo
        ),
        principleDiagnosis: item.diagnosis ?? '',
        remark: item.remark,
        assignedbedNo: item.assignedBedNo ?? '',
        checkBedStatusId: item.changeIdStatus,
        statusState: item.status,
      };
    });
  }, [allData, language, isLogin, bsMlookupList]);

  const doubleClick = (index, type, transferRequestId, eaId) => {
    return () => {
      if (isLogin) {
        if (type === 'EADM') {
          history.push(`/bedstatusForm/${eaId}?transferRequestId=${transferRequestId}`);
        } else {
          showPop(index)();
        }
      } else {
        setLoginPopup(true);
      }
    };
  };

  return (
    <PageList nextPageCall={nextPageCall} pageSize={pageSize} allData={allData} ref={ref} hideIndex={hideIndex}>
      <TableContainer className={classNames(className, classes.root, tablePadding && classes.padd)}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead className={classes.tableHead} id="bed_transfer_tablehead">
            <TableRow>
              {showCheckbox && <TableCell align="left" />}
              <TableCell align="left">{i18n.t('BEDSTATUS_STATUS')}</TableCell>
              <TableCell align="left">{i18n.t('BEDSTATUS_ADMISSION_DATE_TABLE')}</TableCell>
              <TableCell align="left">{i18n.t('BEDSTATUS_ADMISSION_TYPE')}</TableCell>
              <TableCell align="left">{i18n.t('BEDSTATUS_PATIENT')}</TableCell>
              <TableCell align="left">
                {i18n.t('BEDSTATUS_SPECIALTY')}/{i18n.t('BEDSTATUS_HOSPITAL')}/{i18n.t('BEDSTATUS_WARD')}/
                {i18n.t('BEDSTATUS_BED_NO')}
              </TableCell>
              <TableCell align="left">{i18n.t('BEDSTATUS_PRINCIPLE_DIAGNOSIS')}</TableCell>
              <TableCell align="left" style={{ minWidth: remarkMinWidth }}>
                {i18n.t('BEDSTATUS_REMARK')}
              </TableCell>
              <TableCell align="left">
                {i18n.t('BEDSTATUS_ASSIGNED')}
                <br />
                {i18n.t('BEDSTATUS_BED_NO')}
              </TableCell>
              {isHistory && <TableCell align="left">Ack. Date, By, Type</TableCell>}
              {onRead ? null : <TableCell align="left">{i18n.t('BEDSTATUS_EDIT')}</TableCell>}
              {ticket && <TableCell align="left" />}
            </TableRow>
          </TableHead>
          <TableBody className={classes.tableBody} id="bed_transfer_tablebody">
            {rows?.map((row, index) => {
              return (
                <TableRow
                  key={row.id}
                  onDoubleClick={onRead ? null : doubleClick(index, row.admissionType, row.id, row.eaId)}
                  id={`bed_table_row${index}`}
                  selected={showCheckbox && row.statusState === 'O' && row.checkBedStatusId}
                >
                  {showCheckbox && (
                    <TableCell style={{ padding: checkBoxPadding }}>
                      {row.statusState === 'O' && (
                        <Checkbox
                          checked={row.checkBedStatusId}
                          onChange={onChangeCheckbox(row)}
                          className={classes.checkBox}
                          inputProps={{ 'aria-labelledby': index }}
                        />
                      )}
                    </TableCell>
                  )}

                  <TableCell align="left" className={classes.statusCell}>
                    {row.status}
                  </TableCell>
                  <TableCell align="left">{row.dateTime}</TableCell>
                  <TableCell align="left">{row.admissionType}</TableCell>
                  <TableCell align="left">
                    <PatientUI iconBoxSize="2rem" {...row.patient} hkid={row.hkid} />
                  </TableCell>
                  <TableCell align="left">{row.specialty_hospital_ward_bedNoCtr}</TableCell>
                  <TableCell align="left">
                    <div dangerouslySetInnerHTML={{ __html: row.principleDiagnosis?.replaceAll('\n', '<br/>') }} />
                  </TableCell>
                  <TableCell align="left" className={classes.remark}>
                    {row.remark}
                  </TableCell>
                  <TableCell align="left">{row.assignedbedNo}</TableCell>
                  {isHistory && (
                    <TableCell align="left">
                      <AckInfo ackBy={row.ackBy} ackDate={row.ackDate} adTicketType={row.adTicketType} />
                    </TableCell>
                  )}
                  {onRead ? null : (
                    <TableCell align="left" id={`bed_edit_btn${index}`}>
                      {row.edit}
                    </TableCell>
                  )}
                  {row.ackDisplay ? (
                    <TableCell>
                      <StyleButton
                        text="Ack."
                        width="3.875rem"
                        height="3rem"
                        type="fill"
                        onClick={handleAck(row.adTicketId)}
                      />
                    </TableCell>
                  ) : (
                    ''
                  )}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {isShowPop ? (
        <Newbooking
          open={isShowPop}
          closePop={closePop}
          title={i18n.t('BEDSTATUS_TRANSFER_IN_BUTTON')}
          allData={(() => {
            return EditIndex > -1 ? allData[EditIndex] : null;
          })()}
          saveHandle={async (data) => {
            if (saveHandle) {
              (await saveHandle(data, EditIndex)) && closePop();
            }
          }}
          bsMlookupList={bsMlookupList}
          setRefresh={setRefresh}
          setIsLoading={setIsLoading}
          bsMlookupListStatus={bsMlookupListStatus}
        />
      ) : (
        ''
      )}
      {loginPopup && <LoginPop closehandle={() => setLoginPopup(false)} submitHandle={() => setLoginPopup(false)} />}
    </PageList>
  );
});

const getFullName = (chiName, patName) => {
  if (chiName) {
    return `${chiName} ${patName}`;
  }
  return patName;
};

const getMaskedName = (chiName, patName) => {
  if (chiName) {
    return `${maskChineseName(chiName)} ${maskEnglishName(patName)}`;
  }
  return maskEnglishName(patName);
};
